/** Typeguard for Array<string> */
export function isStringArray(variable: unknown): variable is Array<string> {
  return (
    Array.isArray(variable) &&
    variable.every((item) => typeof item === "string")
  );
}
